module.exports = __webpack_public_path__ + "static/media/seda-pharmaceutical-development-services.f58f84bf.jpeg";